import * as React from "react";
import DataGrid, { Column } from "devextreme-react/data-grid";
import { IExpenseComment } from 'src/services/interfaces/Expense/IExpenseComment';
import "./ExpenseCommentsTable.scss";
import { formatDateTime } from 'src/util/Date.helper';

interface IExpenseCommentsTableProps {
  expenseComments: IExpenseComment[];
}

export const ExpenseCommentsTable: React.FC<IExpenseCommentsTableProps> = ({ expenseComments }) => {
  return (
    <DataGrid className="data-grid" dataSource={expenseComments} showBorders columnAutoWidth>
      <Column caption="ID" alignment={"center"} dataField="id" dataType="number" />
      <Column caption="Comentário" dataField="comment" dataType="string" alignment={"center"} />
      <Column caption="Enviado por" dataField="createdUser.fullName" dataType="string" alignment={"center"} />
      <Column caption="Última Atualização" dataField="lastUpdate" alignment={"center"} sortOrder={"desc"}
        cellRender={params => params.data.lastUpdate ? formatDateTime(params.data.lastUpdate) : formatDateTime(params.data.createdDate)}
      />
    </DataGrid>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/ExpenseComments/ModalOption/ExpenseCommentsTable.tsx